import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  phoneValidation: null,
};

export const phoneValidationSlice = createSlice({
  name: "phoneValidation",
  initialState,
  reducers: {
    setPhoneValidation: (state, action) => {
      state.phoneValidation = action.payload;
    },
  },
});

export const { setPhoneValidation } = phoneValidationSlice.actions;

export default phoneValidationSlice.reducer;
